import { render, staticRenderFns } from "./Pods.vue?vue&type=template&id=46ae1eaa&scoped=true&"
import script from "./Pods.vue?vue&type=script&lang=ts&"
export * from "./Pods.vue?vue&type=script&lang=ts&"
import style0 from "./Pods.vue?vue&type=style&index=0&id=46ae1eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae1eaa",
  null
  
)

export default component.exports